module.exports = __webpack_public_path__ + "static/media/gds_gray@3x.b2d75c8e.png";